export const Paths = {
  GROUP_MANAGEMENT: "/groups",
  GROUP_DETAIL: (id) => `/groups/${id || ":id"}`,
  DOCUMENT_MANAGEMENT: "/documents",
  DOCUMENT_RESULT_VIEW: (type, slug) => `/result-viewer/${type || ":type"}/${slug || ":slug"}`,
  TAG_MANAGEMENT: "/tags",
  TAG_DETAIL: (id) => `/tags/${id || ":id"}`,
  HOMEPAGE: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  REGISTRATION_RESEND_ACTIVATION: "/register/activation/resend",
  REGISTRATION_CONFIRM_ACTIVATION: "/register/register/confirm",
  PASSWORD_FORGOT: "/password/forgot",
  PASSWORD_RESET: "/password/reset",
  USER_PROFILE: "/me/profile",
  USER_PROFILE_INFORMATION: "/me/profile",
  USER_PROFILE_ACCOUNT: "/me/profile/account",
  USER_PROFILE_SECURITY: "/me/profile/security",
  USER_PROFILE_API_KEY: "/me/profile/api-key",
  ADMIN_GENERAL_STATISTIC: "/admin/dashboard",
  ADMIN_DOCUMENTS: "/admin/documents",
  ADMIN_USERS: "/admin/users",
  ADMIN_CONTENTS: "/admin/contents",

}
